import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { projectWorkTypesSelector, isBtoBSelector, isAlgarDeskSelector } from '../../selectors';
import { getProjectStatus } from '../page-project-list/helpers';
import { HomeBlock } from '../styled';
import { StatusBadge, StatusHomeBlockContent, StatusHomeBlockTitle, StatusIndicator } from './styled';
function StatusContainer(_ref) {
  let {
    project
  } = _ref;
  const isBtoB = useSelector(isBtoBSelector);
  const isDesk = useSelector(isAlgarDeskSelector);
  const projectStatus = getProjectStatus(project.dealstage, isBtoB, isDesk, project.pipeline, project.flowType);
  return /*#__PURE__*/React.createElement(HomeBlock, {
    centerOnMobile: true
  }, /*#__PURE__*/React.createElement(StatusHomeBlockTitle, null, "Statut"), /*#__PURE__*/React.createElement(StatusHomeBlockContent, null, /*#__PURE__*/React.createElement(StatusBadge, {
    colors: {
      color: projectStatus.color,
      bgColor: projectStatus.bgColor || '#FFF'
    }
  }, projectStatus.title), /*#__PURE__*/React.createElement(StatusIndicator, null, projectStatus.message || '', projectStatus.title === 'Panneau expédié' && /*#__PURE__*/React.createElement("a", {
    href: "https://trace.dpd.fr/fr/trace/" + project.numeroColisPanneau
  }, "Suivez sa livraison ici."))));
}
StatusContainer.propTypes = {
  project: PropTypes.object.isRequired
};
export default StatusContainer;